import request from '../utils/fetch';

/*******签约配置相关接口********/
//获取所有签约类型
export async function getSignTypeListApi(): Promise<any> {
  return request(`/boss/api/v1/sign/type/list`, {
    tokenFree: false,
    method: 'GET',
  });
}
//添加签约类型
export async function addSignTypeApi(params: any): Promise<any> {
  return request(`/boss/api/v1/sign/type`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}
//更新签约类型
export async function updateSignTypeApi(type: string, params: any): Promise<any> {
  return request(`/boss/api/v1/sign/type/${type}`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}
//删除签约类型
export async function deleteSignTypeApi(type: string): Promise<any> {
  return request(`/boss/api/v1/sign/type/${type}`, {
    tokenFree: false,
    method: 'DELETE',
  });
}
//更新签约类型状态
export async function updateSignTypeStatusApi(type: string, status: number): Promise<any> {
  return request(`/boss/api/v1/sign/type/${type}/status/${status}`, {
    tokenFree: false,
    method: 'PATCH',
  });
}

/*******支付配置相关接口********/
//获取后台支持的支付类型及支付方式
export async function getPayTypeSupportApi(): Promise<any> {
  return request(`/boss/api/v1/payment/type/supported`, {
    tokenFree: false,
    method: 'GET',
  });
}
//获取所有签约类型
export async function getPayTypeListApi(): Promise<any> {
  return request(`/boss/api/v1/payment/type/list`, {
    tokenFree: false,
    method: 'GET',
  });
}
//添加签约类型
export async function addPayTypeApi(params: any): Promise<any> {
  return request(`/boss/api/v1/payment/type`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}
//更新签约类型
export async function updatePayTypeApi(type: string, params: any): Promise<any> {
  return request(`/boss/api/v1/payment/type/${type}`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}
//删除签约类型
export async function deletePayTypeApi(type: string): Promise<any> {
  return request(`/boss/api/v1/payment/type/${type}`, {
    tokenFree: false,
    method: 'DELETE',
  });
}
//更新签约类型状态
export async function updatePayTypeStatusApi(type: string, status: number): Promise<any> {
  return request(`/boss/api/v1/payment/type/${type}/status/${status}`, {
    tokenFree: false,
    method: 'PATCH',
  });
}

/******应用设置相关接口******/

//获取所有签约类型
export async function getAppListApi(): Promise<any> {
  return request(`/boss/api/v1/app/list`, {
    tokenFree: false,
    method: 'GET',
  });
}
//添加签约类型
export async function addAppApi(params: any): Promise<any> {
  return request(`/boss/api/v1/app`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}
//更新签约类型
export async function updateAppApi(appId: string, params: any): Promise<any> {
  return request(`/boss/api/v1/app/${appId}`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}
//删除签约类型
export async function deleteAppApi(appId: string): Promise<any> {
  return request(`/boss/api/v1/app/${appId}`, {
    tokenFree: false,
    method: 'DELETE',
  });
}
//删除签约类型
export async function storageFileComplete(fileId: string): Promise<any> {
  return request(`/storage/v1/objects/${fileId}/upload/complete`, {
    tokenFree: false,
    method: 'PUT',
  });
}
